"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchNotificationDetails = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const ui_platform_http_1 = require("@forto-dev/ui-platform-http");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const useFetchNotificationDetails = (notificationID) => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const { current } = (0, frontend_infra_localisation_1.useI18n)();
    const config = (0, ConfigContext_1.useConfigContext)();
    return async () => {
        const url = `${config.NOTIFICATION_CENTER_ENDPOINT}/user-notifications/preview/${notificationID}/${current}`;
        const response = await ui_platform_http_1.HttpBaseApi.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    };
};
exports.useFetchNotificationDetails = useFetchNotificationDetails;
//# sourceMappingURL=useFetchNotificationDetails.js.map